const SUPPORTED_SCOPES = ["franchise", "venue", "warehouse"];

const AUTH_NAMESPACES = {
  franchise: "authf",
  venue: "authv",
  warehouse: "authw",
};

export const getConfiguredImpersonationScope = () => {
  const scope = (process.env.REACT_APP_IMPERSONATION_SCOPE || "franchise").trim().toLowerCase();
  if (!SUPPORTED_SCOPES.includes(scope)) {
    throw new Error("REACT_APP_IMPERSONATION_SCOPE must be franchise, venue, or warehouse");
  }
  return scope;
};

export const getAuthNamespace = (scope) => AUTH_NAMESPACES[scope] || AUTH_NAMESPACES.franchise;

export const getImpersonationScopeFromToken = (token) => {
  if (!token) return null;
  try {
    const encodedPayload = token.split(".")[1].replace(/-/g, "+").replace(/_/g, "/");
    const paddedPayload = encodedPayload.padEnd(Math.ceil(encodedPayload.length / 4) * 4, "=");
    const payload = JSON.parse(window.atob(paddedPayload));
    const scope = payload.scope || payload.auth;
    return payload.isImpersonating && SUPPORTED_SCOPES.includes(scope) ? scope : null;
  } catch (error) {
    return null;
  }
};

export const getUserImpersonationScope = (user) => {
  const scope = user?.scope || user?.auth;
  return user?.isImpersonating && SUPPORTED_SCOPES.includes(scope) ? scope : null;
};

export const getImpersonationTargetName = (user) => {
  const scope = getUserImpersonationScope(user);
  if (scope === "venue") return user?.venue?.name || "this branch";
  if (scope === "warehouse") return user?.warehouse?.name || "this warehouse";
  return user?.franchiseId?.name || "this franchise";
};
